import { useParams } from 'react-router-dom'
import { isFlightsPendingToAddToCart } from 'checkout/selectors/navigationSelectors'
import { flightSearchInProgress, getNonCharterFlightItems } from 'checkout/selectors/view/flights'
import { useAppSelector } from 'hooks/reduxHooks'
import { shouldRenderFlightSessionCountdownClock } from './utils'

export function useShowFlightSessionCountdownClock() {
  const { step = '' } = useParams<'step'>()
  const hasExpirableFlights = useAppSelector(state => getNonCharterFlightItems(state).length > 0)
  const hasFlightsPendingToAddToCart = useAppSelector(isFlightsPendingToAddToCart)
  const isFetchingFlights = useAppSelector(flightSearchInProgress)

  return !hasFlightsPendingToAddToCart &&
    shouldRenderFlightSessionCountdownClock(hasExpirableFlights) &&
    !isFetchingFlights &&
    step !== 'lux-plus'
}
